// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo[data-v-1377a336]{display:flex;align-items:center;justify-content:center;height:100%;width:100%}", ""]);
// Exports
module.exports = exports;
